(function () {
    'use strict';

    angular
        .module('app')
        .factory('workAreaService', workAreaService);


    //2018 SP1 Refactor: 20180827 - GT
    //Added extractionservice
    //Moved 'extractitem' and 'willextract' and 'getplugindefinitions' and 'updateExtractedData' and 'checkftsextract' to extractionservice as 'extractworkareaitem' and 'willextract' and 'plugindefinitions' and 'updateExtractedData' and 'checkftsextract'
    workAreaService.$inject = ['$http', '$q', '$filter', '$timeout', 'gridDataService', 'breadCrumbService', 'loginService', '$localStorage', '$rootScope', '$mdDialog', 'zcs', 'clientService', 'extractionservice'];

    function workAreaService($http, $q, $filter, $timeout, gridDataService, breadCrumbService, loginService, $localStorage, $rootScope, $mdDialog, zcs, clientService, extractionservice) {
        var service = {
            currentWorkArea: null,
            getData: getData,
            getCount: getCount,
            addWorkArea: addWorkArea,
            getWorkAreas: getWorkAreas,
            getWorkArea: getWorkArea,
            setWorkArea: setWorkArea,
            deleteWorkArea: deleteWorkArea,
            data: [],
            testError: testError,
            workAreaModels: [],
            close: close
        };

        Object.defineProperty(service, "currentWorkArea", {
            get: function () {
                var currentWA = "";
                if ($localStorage.selectedWorkAreas) {
                    currentWA = $localStorage.selectedWorkAreas[loginService.id];
                    return currentWA;
                }
                
            },
            set: function (currentWA) {
                $localStorage.selectedWorkAreas[loginService.id] = currentWA;
            }
        });


        return service;


        // ************************************************
        // Work Areas - Begin
        // ************************************************

        /// <summary>
        /// Add a work area from a workAreaModel.
        /// Must have workAreaModel.path set.
        /// </summary>
        /// <returns>WorkAreaModel</returns>
        function addWorkArea(workAreaModel) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/WorkArea/';
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(workAreaModel),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response, status, headers, cfg) {
                deferred.resolve(response.data);
            }, function (err, status) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function FindRealWorkAreaModel(id) {
            var wam = null;
            angular.forEach(service.workAreaModels, function (workAreaModel) {
                if (workAreaModel.workAreaId == id) {
                    wam = workAreaModel;
                    return workAreaModel;
                }
            });
            return wam;
        }

        function SetIcon(workAreaModel) {
            var wa_local_32 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAASdAAAEnQB3mYfeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAALwSURBVDiNnZU9TGNHFIW/O+/Zzz94AeN4SRSINlAhpUyUeBu2SLcFBaKnRkralHSpI6XfHlEgpY7YFHFDl2JXKZB2pUUbEMELxH/P781JYRuDwQLtqUYzc8/ce+7MGeMO/Prbn9+BVoXVDK0g3NWi4QWvJeqBdy+31mr18XgbDrZf7Ocq1cIiPt4A+1rSMmbzBrPX9wESNBD/GBxKHASwc3LWe7u9+axzRbr9Yj/3yVz2K6E1jHWJBTPyd1VxA6JtZu+816683zv7kP61vfmsEwJUqoVFpb01mX40rGB2I7PJMPJCyzj94JyjWnbnwN99rXy8gbFuWOFBZLe4rSC0roANABs05SeJ74clV6enqEwXKeWjiUSX7S6n501Ozv/rKyHahn5Pvf85BK1KWjazvBlEYchidZaFygzFXHYiabMTU4w+cNHq0E0SgDywFLhgNRRWw5gHCJxj7lGRhcoM8+USziZLWypEYPC+ccFx45Je6hH2GOOpM7QyuDZEmZClz+YoFaJ7O2VAKR/x5adzZDPhcG7WxEqIcAy67cwo5SLiJOGi5e+hhdR7SrmIYFSRyXDh9U1CJKnn/dkFcS+9lzQbBuSjDBqbv0HqvWh2Yv69bHLZjvHek3oBwgukUXjgHNPFHNXpKbzXGKnhAQHmJZrdmMA5smFAq5vSjmMExL2UuJdcBT4q5pjyWVrdGD86TGbmQ8FrYMagPFyJMiGZMKCUjwZZ3J1pGI58pi8fDZNehRJ1gycY5STxHJ2e49zDXimAl+glff0NHUvUw8C7l3L+W8STxPv88IV8BNrIHTpn+25rrVaXODCzd/0KbjXzPvRjxBFOB1vPa3UHEMCO99oVan1MikItwa7kdmBwpU7Oem/LM8Gecw6hdWSfP8hPoY04Ats1r71io/sGxpy/Ws58oYANeX2DsSTs8STnN3SM3CFOB5LbmTrtvtm87vzj+GXvj1rgglUZT02syEZ/lJl5pFeS6s4F+1vPb/9R/wMy314Z/U5xDQAAAABJRU5ErkJggg==";
            var wa_local_invalid_32 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAASdAAAEnQB3mYfeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAO1SURBVDiNjZVNbFRVFMd/57735s28YTr9HKclLcE2apqiIYQgJYZiYnTZRcNOEtYkunXZnWsT98SlpDGoiTtsJWmVYFCJFBRqqZQwlGmHaTudmTfv3eOiH/Qz9b+6OffeX845//sh7KMvv588CzqkyKCg/Shma1KwCvdVmXKsmbgyPDi1e79sDkavjifbc0EPNrwIclpV+xDJC7RsXweoQgmlIDCjym0Hri0sNeZGL1+obUFHr44nO9oSJxQdRhhRpVuE1H5V7JBSFZF5a3VMrb2+9DK+O3r5Qs0FaM8FPRo3hlX0U0ECkR2ZHSwhpWgfRj8xxpBrNWXgr/Ve2fAiwoggwf+C7WFLoOiIOlwEkA1TPlPlg82Sc9kjtGfTZFL+gaCVap1iucJCeXW9E0pV0BuxtZ+7oEOq2iciKRHwXZeeXAvd7c2kk4kDoZVaSNp/yfJajXoUAaSAXsc4Q64igwh5AMcY2prSdLc3k2/NYOTg1mYCHwSelZZ5XlqhEVsUeQ3hnBG0f+PY4HsuvV1tZAL/UKcEyKR8Xu9sI+G5m7EWUfpdFMOG20aETNInjCKW1+whWIitJZP0cV5VJCoYd/siRYliy7OlZcJGfCg04TqkfA/dFd8BtVap1EIWVyqsVEOstcRWAcUqqCqoklhexSuXyNiQ1kxA+ukCaxJQb2rGaUnjIlhAAbGqVOohjjEkXIe1ekw1DFEgbMTUGxE0IvK3fid7a5zM7DQx0AusdZ9h5fR7GpzvV1fhPtAs0LqZse+5eK5DJuVjt2X6cr7Igx9+5a3ZSbJxBZPLERWLeJ153owLZO/erM+WS0uuKlMCxxFao8jytFjGmAO8Xyjwxh/jNHsVWs6fJXGsm+r0A9KnTlL55Tby2z3H3HmRdB1rJtTYd1GOR9amNm/IfsouvmBgYRo3lyNxrJum94cIBgbwujqpzz4mVV/1jpYW0+bK8OCUKrdFZH6jt7vN3KOoWKQ6/YBooUjwzgnqj2ao/f2IqFQCWH98HbhmrY4punYYEMDrzJM+dRKvq5PVn2+RGugneHsAt6ODDR6c/vDjSsqXkjGmrGgelUAEb0+GlZDSkwpNtkoialCbmWH5xgSNwnOq96aJCoWCVms3HYCJb7+Kznx0afFI0nksRmJUQ4RYEUcgycZj3lCHsslqcmmxbv6d1fjen07t4UPqc0+ICoWCrdYm4yj6el+bv7j+06BjnCEVzonSr/Lqj5JYNfpucqn3zo/Jo6V/0ltxZNLC2Km5h9/8B5uXsYgTmZEQAAAAAElFTkSuQmCC";
            var wa_network_32 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAASdAAAEnQB3mYfeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAMBSURBVDiNhdVNT1VXFMbx3zr3XIRbQCA1EIFbK6RpaOqk8Q1ryqxTB8SPoQO/AEnHxu/QITGN/QCNjmiMM9NobWKKqRKUtljkRS73nt3BucjlLa5kJydrP+efs9Z59trhiBi9ky5XmBGmMYWsY7uQPE3JQit5sHQrFg6+H7sPZ+ZS906fehauy5wPJiUjKQxGhy6RIlkVllPyHI9aYb7rrReLc/H+A/TMXOpuDfga1ySzGI/Qc1QVnZHYwkvJ3ZTcy9c8XpyL9zns9KlnXMNNodZbFbUqXZXjgY0Wmzt61ndMCjciozHgPzzLIQvXJbNCDb45zfQYE0PHQ5//y68vefAC1CSzlWQLP+Sjd9Jl4bxkvJqJUzW+P8u3dfpPHA/9Yqjc/+MfsbLJTstYSi6cvp2m8wozmBR6alUujnJumPpJsjgeOtDNuwaXxvjlT9YKPcFEMJML05IRwSdVrtYZ7Ga7eTywE3y1zsOXrG0jDEe4kmOqbRt5xnBvKVhvfBxaJEZ6yds/NDEYTOXKKgOaBW/WefiKvzc/Dv20xtmB8j0IIpHlnaJmwfIGKxssr7OxUy7Kdmy39rQnTzAxSK1Ks2Vf7IO2Ull6rcpQD1lW5lKiVZTe3I3unGql1LfSYWiRSEFIpaC3q1xjHcJdJxQHAO+b7KbanCKXPA0GhKG1Bj8/O9pKF0cZ7eOn3/fni3Z17Z6u4kmekoXIfI6hZsGbjcNA2GqWgOX1o/fbn/o6sZC3kgeV5JLweSiHyHg/fQdOU72/tNvUqb3cu23+WvtQ+lYKz4twP1+6FQvjd9IjfJmYhO/OiK9O7YeO9NJbpfvcXu7JCj8+brc0eSU8WroZCzm0wnwl6RFuoPbbm8NtqGZlrztttbKn2UzhbtE0T9tSXW+9aPa7FxmS2cVVY0vvPj5PGy1bklcp3MW9rnWLHJj8jQGfVZLrKbmQhQlhuH309k9+ViWviygnf9E037Vucd/kPxinb6fpSpiJzBVMpY47KijwJCULrcz9pZuH76j/AQAVKMWrQSZEAAAAAElFTkSuQmCC";
            var wa_network_invalid_32 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAASdAAAEnQB3mYfeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAOuSURBVDiNhZVdT1RXFIafdeYcYM4AM0Od4WM+QCFa6YixRBCskfTGeEdTws+wF/4Bkl4brvsHemFMQ0viRdM2JC0goUmTtoICFoiUjoCMxRmGmXPOrF4cqINCXMlOdvZ+97OzPvbawgmWGNeBAAwhDALdgFG1XUFZVGXGU6Y278rM2+flaNIxpnVOA2lDGMXgqkAXSosKUanSKagoOYSsKs+AeU+4X/OK9bUxOfgf2jGmdV6ES8AwygiQEiF4khfVplAENlAeqDJh7vH72pgcmABOA2kDhoEvEOx6C7EtqAmcDix7sO8QzDt0IdwRA8oR/gWemgCGMIoygmAD9LbBYBI6m06HPtuF2Q2YWgfARhkJKEXgSzMxrgMIV1FSloHEbLh1Dj5JQ2Pt6dDzTf7+0ktkex8cj6QqfW33dNAMwBDQhRC0LehPQE8zpMNgyOnQSB28LsO1JPy4CnsVggKdAkMmwiBKCwIhC26kIVoHJfd0YDX4RhrmNmCvBAjNIlw3ge7DssE0oLneF+TL74dWFFrqwTxMqEJUoNvE91IA3Aps5WHub9jZfz/0jA3nIv45AAFRMMxqkVuBbAG2C5DNQ8HxB/jhKHlvtOFa6IyCbYHrccyOQT31XbctaAqCYfhrquBV/NpEldrdLHFnm3i2gPkczq9DiDC5UIxcKIZ5GBoVENSH1Nf4I1l1oXEkcByS3z+k+ZdJGlYXAOgD/kj189PFz3Tq4rCaKIsCEYSmvTJ8+/TkUupPwGWybH33kMjyD4S9AkY8jruzg9XawgUvi7UyWfog/2LXVGVGDM4CTW4FtgonJ6XoQri0TfTXSaJWgejNAWraUxQXnhDqvULh0Tzy2+NA/eJmnekpUwHlGsJZwW8iqUZoeOs1pRshtl0gvLWAGY9T056i8dMh7EwGq62V0uoawVLeSuRehszNuzKTGtd54EOFLoCbHchHsePQlno4UwAHcHd2KC48wc5ksC9fIj87x8HSCm4u9yb7nnA/oAQR7gD2n1vvhsEyILUMtwGrtYVQ7xWstlbys3MEM93YPRkOlldwtl740JpXrLuNTIgBKCNrOZKbr9/tp//shUmm+rngZSk8mqe0usbB0gp2T4bi4wVwnawg08c6fzlCe0AZVaXPEDoRmg+fngBECtt8vPaz3lqZLHUWnweCpbzl5nKYsRi4TrZSPJh2i8WvT+xDbfd0MCAMicF1oFur/qhApaKfz3+1O7Q4UZfI/RU6WhdkugIPeteXv/kPs8ZtPrpTz/0AAAAASUVORK5CYII=";
            var wa_shared_32 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAASdAAAEnQB3mYfeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAQ3SURBVDiNbZRLbxtVGIafc2bssZ2Z2G1jN01iRyGNVIpaURqpBYQadYWgF0qF2FViARtWCLHvLwCpgjULhESRQEhVi1jVECFKFVBCWpKgOHGaxnHtxmk8vs/lsJi0uTTvaBZnvu97zqv3HI1gD/VfUwO6xxkF5xGMAtq2so9iAsEN1+PXwqdiefe82L7ou6piwuK4lLwPvCYEgwpSYlufAiWgpBRLAv7w4LraYKpwVTSegya/UmakzREkHwDnIhqZWAhC2z1uyvGg4UDL4wGKmwi+boWYKX8sagD65v4i2mZQCS4AV8wQZiYOQwmIhp6HNl1YXIcHG2RqDleANa1NA7j/DDrwORFfclrCRwqiJ/vg3SNwdmhXPlsRcHsRfpyFbJ6oEHyoS+aeQuVm32EBLynFAUAeS8HRJMQN6N7jjRtB/VgKEAilOCDg5d5r6ugzpwIOAYekQNdlMISCVXsPm0/dKohHICwRro/uK9IhnzTwrx4kiikUXZoG+6Ngd2BhPRiuNCGig6eg421BDR2qraB/rQnKJ+Z7mNsOKlBYg5H9kH8CtU4A+WEm+GZ3YKW61TtyANLdQa1WBNffqu2Auj6s1oKBVBfYbXh7BGIh8HxobXOaigXr8SVwfHYoyFRQBxquD4/qMF0CM7QTMrwP+kyYWN2MpQF1B0r1wIxSNAk4AVT5FISk4Clcu4M2UXj+JvVEIRmDOw93HVhwwzwFBTwKAHJsbEw/+O3orHQa96XvNqXylPBdhPIQygPlA4puA5Jdu7cKuAJqAiYffib+AdCjZvcXVk9qqGfik8GWnohE4geFkBIRTeCb/VS0JE1zmN+XLf4uBvk+ledD21VtrVH4vqv4Z3l4bKw3m80WxVsXLmXTR44f8z3XbFVK2vmLl6RhRES94/O47rFa9ZivCCq+RS18kEo4jZIhNMfGaBXbiXquYq1Pzh6SG+VUXF9MJpN3dCGEnhwYDLuuG6orR7159g0sy6RYLJLP57Ftmxdi65TbbZYdj78eb6i2L33DtcWAXvJf2bdKLGme0qRpOI63Wq1We/Rd8QSPUnieh1KKvr4+Tpw4gVKKmdk5uP4N9bbj7k9Y4sWR4fDp02d60+k0Kysr/tTUlBwfn4vtgCqlaDWbxKJRAGzbZnJyikpljXDYQEqJEdK4eOFcaOTwMJ7vidz8PLdu3XKrVXvFcZyfa7Xal+L8O+99l8oMjXq+u8+pPdFeHT2p9ff3RSyrW49GI0QiURqNOvV6g06ng67rJBJxHj0q+YVCoVar2cu53OLNZrM1o2ncn56entSlkL+UlhdySqluXUptfPw3LRNoIJPJ9PT29pqGYYhGo4njdIhEDJXP56v37t1bnJ/P/WdZ5ly5XP6pWq0uZbPZFuz9u+Ty5cunLMt6XUp9tN1uZXb1KSm1nOO0bywsLNy+e/fu2u75/wH2Yeg19QehYAAAAABJRU5ErkJggg==";
            var wa_shared_invalid_32 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAASdAAAEnQB3mYfeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARLSURBVDiNbZTNb1RVGIefcz+mM3c++mUHOv2mIm2dIk0xiMbQsDAYgYUsNCaSuNCNS/8B/gJNMK5dsJFE2RBdEI2IIBKbAMGWSoG2tHRuh+lMO3em987cj+PiFjqlfU/u4pz3fZ/zu79zcgS7RNd52a35HJNwCsFhQG1IB0gmEVz2fP5Y/kosvtwvGieZc9IQSQ4qCh8BbwtBn4S0aKiTIAXkpWRBwE0fLsp17i6fExs7oB3fyUS0xhAKnwEnoyq9hg56o8bNcH3YcMHxeYLkZwTfOzr3n30pKgDa5v4iVqNPCk4DZxM6id5mGGiBmL4TanswV4In6/RWXM4Cq2qNDWDqBbT7a6KBwlsKfCEhNp6BD4fg+MBL/mxZwO9zcGkGrs4TE4LPNYX/nkOVzbpXBbwuJe2AMpqGkQ5oboLULl9zU5gfTQMCISXtAg7tPS9HXigV0Al0KgJNU8ImJOSsXWQ+VyuhOQoRBeEFaIGkRw/oAaa10FESQhJXVWiLgVWHx6WwuWhDVANfQt3fgjZpUHbC+lUbZIAR+CQaDiqMiAr722B+DSr1EPLT/XDNqsPT8lbt/nboSYW5iglesJXbBvUCyFXChnQcrBp8sB8MHfwAnAalaSOc/7kAbsC2CD0VVIENL4CVKtzLQ0LfDhlshUwCJnObtmxA1YV8NRQjJTYhJ4TKgGWhsOxLPKuOOrm88ya9Egt/9+m6pKloEll7hmpX6d/MC0gpUrYsAWJiYkKzLEsUPr52FjXyDULEkVJBhFyJACH4JCs4MSi5vejSfeUCe65fJjk3/WLTez1HWGh77Qe/HHwq3j95+lstGh2oqy19jtZyINq8RxOKIkSshSDRRVHtwE4M0tqcZKCeY+jOL7w5+yvpWgHFsfEKBfTOvVSlTp7U0oPU4BVNKOpoZt/waOB7CaeYV069N0FTU5RqPaBQ9cmVczwsmhQrSbxSgQOTl2nVq7QeO0qkrwd7eob4+BjVv/9B3J7aw8rdo5oQQuvo7ot4nqdXpStPHH+XZDKBaZrMz89jWRb7jBLPajUMZ5l9+Wm0dJpIXw+p4xMY2Sx6ppPa3DyxWkXvKq3Gte3HIcMhJb7vI6Ukk8kwNjaGlJL1639RuQBeoYA9PYORzWK8MUrl5i2cBw/xSqWd91RKiWPbGLEYAJZlcefOXYrFVSKRJrqKJUYAvXMv8fEx9EwnlZu3iGVHMA5mcWYf4uZXUIeGs+9J32+2inmq5ZJbXlvzTDOnWFZFiccN+vv76erK0NbWhnRVlhY9UoFNxHNxHj2i/NtVXHMFe2oazzRNaTvX1OHh0WSlXMxtlNce+HV36unSk6lyubzqunVH1/XAMAw0TXMdp+aurJbdmULdTWxUPX15EX/qX9WZnaW2sIhnmmZgOzd8z7u423PJmTNnjiSTyXcURTtcqzm9NDyrAsGBcrt6aHE61VV6HG9YvxHAj+MLs5f+B1II74HacGnkAAAAAElFTkSuQmCC";

            // Calculate Icon
            //workAreaModel.icon = workAreaIcon;
            var bShared = false;
            if (workAreaModel.shared == "P" || workAreaModel.shared == "C")
                bShared = true;
            var ValidationState_Unchecked = 0;
            var ValidationState_Valid = 1;
            var ValidationState_Invalid = 2;
            var DriveType_Local = "L";
            var DriveType_Network = "N";
            if (workAreaModel.validationState == ValidationState_Valid) {
                if (bShared) {
                    workAreaModel.icon = wa_shared_32;
                }
                else if (workAreaModel.type == DriveType_Network) {
                    workAreaModel.icon = wa_network_32;
                }
                else {
                    workAreaModel.icon = wa_local_32;
                }
            }
            else {
                if (bShared) {
                    workAreaModel.icon = wa_shared_invalid_32;
                }
                else if (workAreaModel.type == DriveType_Network) {
                    workAreaModel.icon = wa_network_invalid_32;
                }
                else {
                    workAreaModel.icon = wa_local_invalid_32;
                }
            }
        }


        /// <summary>
        /// Get a list of work areas where the current user is the owner or a member of a shared work area.
        /// </summary>
        /// <returns>List of WorkAreaModel</returns>
        function getWorkAreas(bHitServer) {
            var deferred = $q.defer();
            if (!bHitServer && service.workAreaModels.length > 0) {
                deferred.resolve(service.workAreaModels);
            }
            else {
                var url = '../Synergis.WebApi/api/WorkArea/List';
                $http.get(url).then(function (response) {

                    // Don't push anything to the service until the end.
                    //service.workAreaModels = response.data;
                    var wams = response.data;

                    // Validate all work areas.
                    zcs.ValidateWorkAreas(wams).then(function (response) {

                        // Don't push anything to the service until the end.
                        //service.workAreaModels = response;
                        wams = response;

                        var promiseArr = $q.all([]);

                        // Walk the work areas.
                        angular.forEach(wams, function (workAreaModel, value) {     
                            promiseArr = promiseArr.then(function () {
                                var d = $q.defer();
                                zcs.GetLocalPath(workAreaModel.path, false).then(function (path) {
                                    SetIcon(workAreaModel);

                                    // Calculate the name.
                                    workAreaModel.origName = workAreaModel.name;
                                    workAreaModel.displayName = workAreaModel.label;
                                    if (workAreaModel.displayName == null || workAreaModel.displayName.length < 1)
                                        workAreaModel.displayName = workAreaModel.origName;
                                    workAreaModel.name = workAreaModel.displayName;
                                    workAreaModel.pathLocal = path;
                                    d.resolve();
                                }, function (error) {
                                    d.reject(error);
                                });
                                return d.promise;
                            });
                        });

                        promiseArr.then(function () {
                            // Sort because name could be the label.
                            wams.sort(function (a, b) {
                                if (a.name.toUpperCase() < b.name.toUpperCase())
                                    return -1;
                                if (a.name.toUpperCase > b.name.toUpperCase())
                                    return 1;
                                return 0;
                            });
                            // Ready for use by others.
                            service.workAreaModels = wams;

                            deferred.resolve(service.workAreaModels);
                        });



                    }, function (err, status) {
                        deferred.reject(err)
                    });
                }, function (err, status) {
                    deferred.reject(err);
                });
            }
            return deferred.promise;
        }

        /// <summary>
        /// Get a WorkAreaModel by work area ID.
        /// </summary>
        /// <param name="workAreaId">Work area ID.</param>
        /// <returns>WorkAreaModel</returns>
        function getWorkArea(workAreaId) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/WorkArea/';
            url = url.concat(workAreaId);
            $http.get(url).then(function (response) {
                zcs.GetLocalPath(response.data.path, false).then(function (resp) {
                    response.data.path = resp;
                    deferred.resolve(response.data);
                });
            }, function (err, status) {
                deferred.reject(err);
            });
            return deferred.promise;
        }


        /// <summary>
        /// Get a WorkAreaModel by work area ID.
        /// </summary>
        /// <param name="workAreaId">Work area ID.</param>
        /// <returns>WorkAreaModel</returns>
        function processWorkAreaItems(workAreaId, path, paging) {
            var deferred = $q.defer();
            service.progress = 0;

            if (!paging) {
                //get the local workarea items
                getLocalWorkAreaItems(workAreaId, path).then(function (workAreaModel) {

                    // Update Validation.
                    var ValidationState_Valid = 1;
                    var ValidationState_Invalid = 2;
                    var realWorkAreaModel = FindRealWorkAreaModel(workAreaId);
                    if (realWorkAreaModel != null) {
                        if (workAreaModel.pathExists) {
                            // If this was invalid, fix it.
                            if (realWorkAreaModel.validationState != ValidationState_Valid) {
                                realWorkAreaModel.validationState = ValidationState_Valid;
                                SetIcon(realWorkAreaModel);
                            }
                        }
                        else {
                            // If this was valid, make it invalid.
                            if (realWorkAreaModel.validationState == ValidationState_Valid) {
                                realWorkAreaModel.validationState = ValidationState_Invalid;
                                SetIcon(realWorkAreaModel);
                            }
                        }
                    }
                    // Was still showing records.
                    if (!workAreaModel.pathExists) {
                        var msg = loginService.resourceStrings["WORK_AREA_ACCESS"];
                        var title = loginService.resourceStrings["ERROR"];
                        $rootScope.msgBoxShow(msg, title);
                        return deferred.reject();
                    }

                    //get items that need extraction
                    getExtractionItems(workAreaModel).then(function (response) {
                        var extractionItems = response.data;

                        if (extractionItems != null) {
                            var invalidItemsArray = extractionItems.invalidItems;
                            if (invalidItemsArray != null && invalidItemsArray.length > 0) {
                                //var gateKeeperController = $injector.get('gateKeeperController');
                                $mdDialog.show({
                                    parent: angular.element(document.body),
                                    templateUrl: 'app/gateKeeper/gateKeeper.html',
                                    controller: 'gateKeeperController',
                                    fullscreen: false,
                                    locals: {
                                        path: path,
                                        invalidItemsArray: invalidItemsArray
                                    }
                                });
                            }
                        }

                        //2018 SP1: 20180828 - GT
                        //added qualifying service to call
                        //get plug-in definitions
                        extractionservice.getPluginDefinitions().then(function () {
                            var promise = $q.all([]);

                            //2018 SP1 Refactor: 20180828 - GT
                            //added qualifying service to willExtract call
                            // Bill 11/30/20-17 #24034 AWC-Extraction message showing when not extracting file
                            extractionservice.willExtract(workAreaModel, extractionItems.items).then(function (items) {

                                //willExtract has returned an array of only the items that will extract
                                extractionItems.items = items;

                                //calculate the progress
                                var itemValue = 100 / extractionItems.items.length;

                                //if there are items to extract, loop over them synchronously
                                if (extractionItems.items.length > 0) {
                                    service.extracting = true;

                                    //extract data for each item
                                    extractionItems.items.forEach(function (item, index) {

                                        //chain the promises so each item executes after the first one is done
                                        promise = promise.then(function () {
                                            //since the chained promise needs to be resolved, we will create a new deferred object
                                            var d = $q.defer();
                                            service.processingItem = item.Name;
                                            //extract the item
                                            //2018 SP1 Refactor: added the qualifying service for extractWAItem call
                                            extractionservice.extractWAItem(workAreaModel.Path + item.Name, item.extractText).then(function (extractedData) {
                                                service.progress = service.progress + itemValue;
                                                //update the extracted data
                                                if (extractedData) {
                                                    extractedData.AdeptTableNumber = 1;
                                                    extractedData.AdeptFileId = item.FileId;
                                                    extractedData.AdeptMajorRevision = item.MajorRevision;
                                                    extractedData.AdeptMinorRevision = item.MinorRevision;
                                                    //2018 SP1 Refactor: 20180828 - GT
                                                    //added qualifying service 
                                                    extractionservice.updateExtractedData(extractedData).then(function () {
                                                        //resolve the promise
                                                        d.resolve();
                                                        if (index + 1 == extractionItems.items.length) {
                                                            service.extracting = false;
                                                            deferred.resolve();
                                                        }
                                                    }, function (error) {
                                                        var message = "";
                                                        if (error.data) {
                                                            message = error.data.ExceptionMessage ? error.data.ExceptionMessage : error.data.message;
                                                        }
                                                        //updateExtractedData error handler
                                                        var confirm = $mdDialog.confirm()
                                                            .title(loginService.resourceStrings['ERROR_UPDATING_EXTRACTED_DATA'])
                                                            .textContent(message)
                                                            .ariaLabel(loginService.resourceStrings['ERROR'])
                                                            .ok(loginService.resourceStrings['CONTINUE'])
                                                            .cancel(loginService.resourceStrings['CANCEL']);

                                                        $mdDialog.show(confirm).then(function () {
                                                            //if the user selects continue we will resolve the sub promise
                                                            //if the item is the last item then resolve the main promise
                                                            if (index + 1 == extractionItems.items.length) {
                                                                service.extracting = false;
                                                                deferred.resolve();
                                                            }
                                                            d.resolve();
                                                        }, function () {
                                                            //if the user cancels resolve the main promise and reject the sub promise to break the loop
                                                            deferred.resolve();
                                                            service.extracting = false;
                                                            d.reject();
                                                        });
                                                    });
                                                }
                                                else {
                                                    //no extracted data, resolve the sub promise
                                                    d.resolve();
                                                    if (index + 1 == extractionItems.items.length) {
                                                        service.extracting = false;
                                                        deferred.resolve();
                                                    }
                                                }
                                            }, function (error) {
                                                //extractionservice.extractWAItem error handler
                                                var message = "";
                                                if (error.data) {
                                                    message = error.data.ExceptionMessage ? error.data.ExceptionMessage : error.data.message;
                                                }

                                                //show confirm dialog
                                                var confirm = $mdDialog.confirm()
                                                    .title(loginService.resourceStrings['ERROR_EXTRACTING_DATA'])
                                                    .textContent(message)
                                                    .ariaLabel(loginService.resourceStrings['ERROR'])
                                                    .ok(loginService.resourceStrings['CONTINUE'])
                                                    .cancel(loginService.resourceStrings['CANCEL']);

                                                $mdDialog.show(confirm).then(function () {
                                                    //if the user selects continue we will resolve the sub promise
                                                    //if the item is the last item then resolve the main promise
                                                    service.progress = service.progress + itemValue;
                                                    if (index + 1 == extractionItems.items.length) {
                                                        service.extracting = false;
                                                        deferred.resolve();
                                                    }
                                                    d.resolve();
                                                }, function () {
                                                    //if the user cancels resolve the main promise and reject the sub promise to break the loop
                                                    service.extracting = false;
                                                    deferred.resolve();
                                                    d.reject();
                                                });


                                            });
                                            return d.promise;
                                        });
                                    });
                                }
                                else {
                                    deferred.resolve();
                                }
                            }); //willExtract


                        }, function (err) {
                            //getPluginDefinitions error handler
                            deferred.reject(err);
                        });

                    }, function (err, status) {
                        //getExtractionItems error handler
                        deferred.reject(err);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }, function (err) {
                    //GetLocalWorkAreaItems error handler
                    deferred.reject(err);
                }, function (err) {
                    deferred.reject(err);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function getLocalWorkAreaItems(workAreaId, path) {
            var deferred = $q.defer();
            var url = 'workarea/items?id=' + workAreaId + '&path=' + path;          
            url = encodeURI(url);
            url = url.replace(/#/g, '%23');
            //get the local workarea items
            clientService.get(url).then(function (response) {
                deferred.resolve(response);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getExtractionItems(workAreaModel) {
            var url = '../Synergis.WebApi/api/WorkArea/Select/';
            url = url.concat(workAreaModel.WorkAreaId);
            return $http.put(url, JSON.stringify(workAreaModel));
        }

        function getData(skip, take, totalRecords, sort, sortOrder, countOperation, resultType, columns) {
            var deferred = $q.defer();
            var canceller = $q.defer();
            var cancel = function (reason) {
                canceller.resolve(reason);
            }

            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            service.processing = true;

            if (!service.currentWorkArea) {
                service.currentWorkArea = $localStorage.userSettings["currentWorkArea"];
            }
            else {
                $localStorage.userSettings["currentWorkArea"] = service.currentWorkArea;
            }


            //process the work area items
            processWorkAreaItems(service.currentWorkArea.workAreaId, service.currentWorkArea.path, skip > 0).then(function () {

                var request = $http({
                    url: '../Synergis.WebApi/api/WorkArea/Data',
                    method: 'POST',
                    timeout: canceller.promise,
                    responseType: responseType,
                    data: JSON.stringify({
                        WorkAreaId: service.currentWorkArea.workAreaId,
                        Skip: skip,
                        Take: take,
                        Sort: { SortField: sort, SortOrder: sortOrder },
                        ResultType: resultType
                    }),
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then(function (response) {
                    service.processing = false;
                    gridDataService.serviceIdentifier = "workAreaService";
                    deferred.resolve(response);


                    //Breadcrumb
                    breadCrumbService.category = loginService.resourceStrings["WORK_AREA"];
                    breadCrumbService.details = service.currentWorkArea.name;
                    breadCrumbService.node = null;

                }, function (response) {
                    service.processing = false;
                    deferred.reject(response);
                    }).then(function (response) {
                        //after the processing of the work area items, call for release of application objects used in extractions
                        //TODO: need to account for empty work area or non-extracting work area items 
                            //do we evaluate the items to extract or move this function

                        //alert("done with work area items");

                        extractionservice.releasePluginApplications();
                    });
            }, function (error) {
                deferred.reject(error);
            });

            return {
                promise: deferred.promise,
                cancel: cancel
            }
        }

        function getCount() {
            var deferred = $q.defer();
            deferred.resolve(100);
            return deferred.promise;
        }

        /// <summary>
        /// Set work area path, comment, and drive type from a workAreaModel.
        /// </summary>
        /// <param name="workAreaId">Work area ID to set.</param>
        /// <param name="workAreaModel">WorkAreaModel to set.</param>
        /// <returns>WorkAreaModel</returns>
        function setWorkArea(workAreaId, workAreaModel) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/WorkArea/';
            url = url.concat(workAreaId);
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(workAreaModel),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response, status, headers, cfg) {
                deferred.resolve(response.data);
            }, function (err, status) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        /// <summary>
        /// Delete a work area by work area ID.
        /// </summary>
        /// <param name="workAreaId">Work area ID to delete.</param>
        /// <returns>WorkAreaModel</returns>
        function deleteWorkArea(workAreaId) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/WorkArea/';
            url = url.concat(workAreaId);
            var request = $http({
                url: url,
                method: 'DELETE',
                data: JSON.stringify(""),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response, status, headers, cfg) {
                deferred.resolve(response.data);
            }, function (err, status) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        // ************************************************
        // Work Areas - End
        // ************************************************


        //from mozilla
        function b64ToUint6(nChr) {

            return nChr > 64 && nChr < 91 ?
                nChr - 65
                : nChr > 96 && nChr < 123 ?
                    nChr - 71
                    : nChr > 47 && nChr < 58 ?
                        nChr + 4
                        : nChr === 43 ?
                            62
                            : nChr === 47 ?
                                63
                                :
                                0;

        }

        function base64DecToArr(sBase64, nBlocksSize) {

            var
                sB64Enc = sBase64.replace(/[^A-Za-z0-9\+\/]/g, ""), nInLen = sB64Enc.length,
                nOutLen = nBlocksSize ? Math.ceil((nInLen * 3 + 1 >> 2) / nBlocksSize) * nBlocksSize : nInLen * 3 + 1 >> 2, taBytes = new Uint8Array(nOutLen);

            for (var nMod3, nMod4, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
                nMod4 = nInIdx & 3;
                nUint24 |= b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
                if (nMod4 === 3 || nInLen - nInIdx === 1) {
                    for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++ , nOutIdx++) {
                        taBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
                    }
                    nUint24 = 0;

                }
            }

            return taBytes;
        }

        function testError() {
            var d = $q.defer();
            $http.get('../Synergis.WebApi/api/WorkArea/error').then(function () {
                d.resolve();
            }, function (error) {
                d.reject(error);
            });
            return d.promise;
        }

        function close() {
            //service.currentWorkArea = null;
            service.pluginDefinitions = [];
            service.data = [];
            service.workAreaModels = [];
        }

    }
})();